// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8440":"cf854bd9f432be23","8855":"805be32e39000dc8","9116":"7f430e9d50aed760","9721":"a498ec6b551ba9b0"}[chunkId] + ".css";
};